module.exports = __webpack_public_path__ + "static/media/guide_img1_2_m.7fc0849f.png";